import { supabase } from "./supabase";

export interface DailySong {
  artist: string;
  title: string;
  itunesId?: string;
  titleHe?: string | null;
  artistHe?: string | null;
  titleEn?: string | null;
  artistEn?: string | null;
}

export interface DailyChallenge {
  song: DailySong;
  challengeNumber: number;
  challengeId: string;
  genre?: string;
  year?: number;
}

export function getTodayKey(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** Fetch today's challenge via the DB function (deterministic random) */
export async function fetchDailyChallenge(dateKey: string): Promise<DailyChallenge | null> {
  const { data, error } = await supabase.rpc("get_daily_challenge", {
    target_date: dateKey,
  });

  if (error || !data?.length) {
    console.warn("Failed to fetch daily challenge:", error?.message);
    return null;
  }

  const row = data[0];
  return {
    song: {
      title: row.title,
      artist: row.artist,
      itunesId: row.itunes_id,
      titleHe: row.title_he ?? null,
      artistHe: row.artist_he ?? null,
      titleEn: row.title_en ?? null,
      artistEn: row.artist_en ?? null,
    },
    challengeNumber: row.challenge_number,
    challengeId: row.challenge_id,
    genre: row.genre,
    year: row.year,
  };
}

/** Fallback if Supabase is down */
export function getFallbackSong(dateKey: string): DailySong {
  const fallback = [
    { artist: "Beethoven", title: "Für Elise" },
    { artist: "Miles Davis", title: "So What" },
    { artist: "B.B. King", title: "The Thrill Is Gone" },
    { artist: "Dolly Parton", title: "Jolene" },
    { artist: "Daft Punk", title: "Around the World" },
  ];
  let hash = 0;
  for (let i = 0; i < dateKey.length; i++) hash = (hash * 31 + dateKey.charCodeAt(i)) | 0;
  return fallback[Math.abs(hash) % fallback.length];
}
